import React, { useEffect, useMemo, useState } from "react";
import AttendanceCodeMappingPanel from "../AttendanceCodeMappingPanel";
import BiometricDevicesIntegrationPanel from "../BiometricDevicesIntegrationPanel";

const SIDEBAR_ITEMS = [
  { key: "codeMapping", label: "Import & export code mapping", screen: "attendance_code_mapping" },
  { key: "devices", label: "Biometric & API devices", screen: "attendance_devices" },
];

const defaultCanSettingsScreen = () => true;

/**
 * @param {(screenKey: string, action?: string) => boolean} [canSettingsScreen]
 */
const ConfigurationStructureTab = ({ darkMode, canSettingsScreen }) => {
  const canScreen = canSettingsScreen || defaultCanSettingsScreen;
  const visibleItems = useMemo(
    () => SIDEBAR_ITEMS.filter((item) => canScreen(item.screen, "view")),
    [canScreen]
  );

  const [activeSection, setActiveSection] = useState(
    () => visibleItems[0]?.key || "codeMapping"
  );

  useEffect(() => {
    if (!visibleItems.length) return;
    if (!visibleItems.some((i) => i.key === activeSection)) {
      setActiveSection(visibleItems[0].key);
    }
  }, [visibleItems, activeSection]);

  if (!visibleItems.length) {
    return (
      <div className="flex h-full items-center justify-center p-6">
        <p className="ds-body text-[hsl(var(--ds-muted-fg))]">
          No codes or devices settings available for your role.
        </p>
      </div>
    );
  }

  return (
    <div className="flex h-full min-h-0 flex-col">
      <h3 className="ds-h3 shrink-0 px-4 pt-3 text-[hsl(var(--ds-fg))] sm:px-6 sm:pt-4">
        Codes and devices
      </h3>
      <div className="flex min-h-0 flex-1">
        <aside className="w-64 shrink-0 overflow-y-auto border-r border-[hsl(var(--ds-border))] bg-[hsl(var(--ds-muted)/0.45)]">
          <nav className="space-y-1 p-2">
            {visibleItems.map((item) => (
              <button
                key={item.key}
                type="button"
                title={item.label}
                onClick={() => setActiveSection(item.key)}
                className={`${
                  activeSection === item.key
                    ? "ds-page-nav-item ds-page-nav-item-active"
                    : "ds-page-nav-item"
                } whitespace-nowrap`}
              >
                {item.label}
              </button>
            ))}
          </nav>
        </aside>
        <div className="min-w-0 flex-1 overflow-y-auto bg-[hsl(var(--ds-bg))] p-4 lg:p-6">
          {activeSection === "codeMapping" && (
            <AttendanceCodeMappingPanel darkMode={darkMode} />
          )}
          {activeSection === "devices" &&
            (canScreen("attendance_devices", "view") ? (
              <BiometricDevicesIntegrationPanel
                darkMode={darkMode}
                canEdit={
                  canScreen("attendance_devices", "edit") ||
                  canScreen("attendance_devices", "create")
                }
              />
            ) : (
              <p className="ds-body text-[hsl(var(--ds-muted-fg))]">
                You do not have permission to view devices.
              </p>
            ))}
        </div>
      </div>
    </div>
  );
};

export default ConfigurationStructureTab;
